import type { InspectionTemplate } from 'inspection-types';

import type {
  OperationFailure,
  OpKey,
  PendingOp,
  RefreshAttempt,
  ReplicaStatus,
  SectionId,
  StaleReason,
} from '../model/operations';

export type TemplateIdentity = {
  templateId: string;
  channelId: string;
};

export type FailedOperation = {
  op: PendingOp;
  failure: OperationFailure;
};

export type CustomizationState = TemplateIdentity & {
  replica: InspectionTemplate | null;
  replicaStatus: ReplicaStatus;
  staleReason: StaleReason | null;
  refreshAttempt: RefreshAttempt;
  pendingOps: Record<OpKey, PendingOp>;
  failures: Record<OpKey, FailedOperation>;
  expandedBySectionId: Record<string, boolean>;
  activeSectionId: SectionId | null;
};

export function createInitialState(
  identity: TemplateIdentity
): CustomizationState {
  return {
    ...identity,
    replica: null,
    replicaStatus: 'loading',
    staleReason: null,
    refreshAttempt: { status: 'idle' },
    pendingOps: {},
    failures: {},
    expandedBySectionId: {},
    activeSectionId: null,
  };
}
